module.exports = __webpack_public_path__ + "img/OTP-Verification.b8c903ef.png";